import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth/authStore';
import type { UserRole } from '@/lib/types/domain';

interface Props {
  allow: UserRole[];
}

export function RoleOutlet({ allow }: Props) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to="/app" replace />;
  return <Outlet />;
}
